module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.posts) ? _c('section', {
    staticClass: "grid",
    class: _vm.classes
  }, [(_vm.renderColumns) ? _vm._l((_vm.columns), function(column, index) {
    return _c('div', {
      staticClass: "grid__column",
      style: (_vm.getDelay(index))
    }, [_vm._l((column), function(post) {
      return _c('post-preview', {
        key: post,
        staticClass: "grid__item",
        attrs: {
          "post": post,
          "params": _vm.params
        }
      })
    }), _vm._v(" "), (!~(index - _vm.columns.length) && _vm.link) ? _c('button-link', {
      staticClass: "grid__link",
      attrs: {
        "to": _vm.link.to,
        "type": "border"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.link.label) + "\n      ")]) : _vm._e()], 2)
  }) : _vm._l((_vm.posts), function(post, index) {
    return _c('post-preview', {
      key: post,
      staticClass: "grid__item",
      style: (_vm.getDelay(index)),
      attrs: {
        "post": post,
        "params": _vm.params
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-766ebc5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/blog/PostGrid.vue
// module id = 644
// module chunks = 1